<template>
  <component
    :is="src ? 'div' : 'label'"
    class="ui-image"
    :class="{ 'ui-image_has-src': src }"
    :style="{
      width: `${width || size}px`,
      height: `${height || size}px`,
      'min-width': `${width || size}px`,
    }"
    @click="clickHandler"
  >
    <input :ref="inputRef" type="file" class="d-none" @change="addImage" />
    <template v-if="src">
      <div class="ui-image__picture" :style="{ 'background-image': `url(${src})` }" />
      <div
        class="ui-image__actions"
        :style="{
          width: `${width || size}px`,
          height: `${height || size}px`,
          'min-width': `${width || size}px`,
          padding: `${(width || size) / 9}px`,
        }"
      >
        <Icon type="trash" size="24" color="oncolor" @click.native.stop="$emit('delete-image')" />
        <Icon type="refresh" size="24" color="oncolor" @click.native.stop="refreshImage" />
      </div>
    </template>
    <template v-else>
      <Icon type="plus" size="16" color="secondary" />
      <Icon type="image" size="32" color="secondary" />
    </template>
  </component>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'UiImage',
    components: {
      Icon,
    },
    props: {
      id: {
        type: [String, Number],
        default: '',
      },
      size: {
        type: Number,
        default: 150,
      },
      height: {
        type: Number,
      },
      width: {
        type: Number,
      },
      src: {
        type: String,
        default: '',
      },
    },
    computed: {
      inputRef() {
        return `image-uploader-input-${this.id}`;
      },
    },
    methods: {
      clickHandler() {
        if (!this.src) {
          this.$emit('add-image');
        } else {
          this.$emit('open-image');
        }
      },
      addImage(e) {
        const files = e.target.files;
        this.file = files[0];
        let fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.onloadend = () => {
          this.$emit('upload-image', files[0]);
        };
      },
      refreshImage() {
        this.$refs[this.inputRef].click();
      },
    },
  };
</script>

<style lang="scss">
  @import 'src/styles/colors';
  .ui-image {
    border: 1px solid $surface-border;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    background-color: white;
    &__picture {
      height: 100%;
      width: 100%;
      background-size: cover;
    }
    &__actions {
      display: none;
    }
    &__img {
      max-width: 100%;
      max-height: 100%;
    }
    &_has-src:hover {
      .ui-image {
        &__picture {
          filter: brightness(75%);
        }
        &__actions {
          position: absolute;
          z-index: 1;
          display: flex;
          align-items: flex-end;
          justify-content: space-around;
        }
      }
    }
  }
</style>
